export function parseCSV(text: string): Record<string, string>[] {
  const records = splitCSVRecords(text);
  if (records.length < 2) return [];

  const headers = parseCSVLine(records[0]).map(normalizeHeader);
  const rows: Record<string, string>[] = [];

  for (let i = 1; i < records.length; i++) {
    const values = parseCSVLine(records[i]);
    const row: Record<string, string> = {};

    headers.forEach((header, idx) => {
      if (!header) return;
      row[header] = (values[idx] || "").trim();
    });

    if (row["Item Id"] || row["item_id"]) {
      rows.push(row);
    }
  }

  return rows;
}

function parseCSVLine(line: string): string[] {
  const result: string[] = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        current += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === "," && !inQuotes) {
      result.push(current);
      current = "";
    } else {
      current += char;
    }
  }
  result.push(current);
  return result;
}

function splitCSVRecords(text: string): string[] {
  const normalized = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  const records: string[] = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < normalized.length; i++) {
    const char = normalized[i];

    if (char === '"') {
      if (inQuotes && normalized[i + 1] === '"') {
        current += '"';
        i++;
        continue;
      }

      inQuotes = !inQuotes;
      current += char;
      continue;
    }

    if (char === "\n" && !inQuotes) {
      if (current.trim()) {
        records.push(current);
      }
      current = "";
      continue;
    }

    current += char;
  }

  if (current.trim()) {
    records.push(current);
  }

  return records;
}

function normalizeHeader(header: string): string {
  return header
    .replace(/^\uFEFF/, "")
    .replace(/[\u200B-\u200D\u2060]/g, "")
    .trim();
}
